import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { getPaymentsHaveFromAndToAccount, getPaymentsRequireAuthorisers } from '../../../states/payments/selectors';
import { getBatchPaymentRequiresAuthorisers, isBatch, isBatchTRAObligate } from '../../../states/batch/selectors';
import PageNavigation from '../../../sharedComponents/PageNavigation/PageNavigation';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import reviewContent, { contentPropTypes } from './review.content';
import ReviewBatch from './ReviewBatch';
import ReviewPayments from './ReviewPayments';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import Notifications from '../../../sharedComponents/Notifications';
import { EnhancedBatchProgressTakeover } from '../../../sharedComponents/BatchProgressTakeover/BatchProgressTakeover';
import { isTransferOrCCPaymentSME } from '../../../effectiveWarning/state/selectors';
import { goToPage, pages } from '../../../states/page/actions';
import { isManagePaymentEdit } from '../../../states/modes/selectors';

const mapState = (state) => ({
	canContinue: getPaymentsHaveFromAndToAccount(state),
	isBatch: isBatch(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	authorisersRequired: getBatchPaymentRequiresAuthorisers(state) || getPaymentsRequireAuthorisers(state),
	isTRAObligate: isBatchTRAObligate(state),
	isTransferOrCCPayment: isTransferOrCCPaymentSME(state),
	isManagePaymentEdit: isManagePaymentEdit(state),
});

const mapDispatch = (dispatch) => ({
	navigateToEffectiveWarningPage: (page) => dispatch(goToPage(page)),
});

class Review extends Component {
	constructor(props) {
		super(props);
		this.handleContinue = this.handleContinue.bind(this);
	}

	componentDidMount() {
		const { handlePaymentInReview } = this.props;
		handlePaymentInReview(true);
	}

	componentWillUnmount() {
		const { handlePaymentInReview } = this.props;
		handlePaymentInReview(false);
	}

	handleContinue() {
		const { navigateToEffectiveWarningPage, isTransferOrCCPayment, handleContinue, isManagePaymentEdit } = this.props;
		if (isTransferOrCCPayment || isManagePaymentEdit) return handleContinue();
		return navigateToEffectiveWarningPage(pages.EffectiveWarning.paymentReason);
	}

	render() {
		const { authorisersRequired, canContinue, isBatch, content, hasApiCallInProgress, handleBack, isTRAObligate } =
			this.props;
		const reviewContent = isTRAObligate ? 'traObligateContent' : 'content';

		return (
			<div>
				<BackButton onClick={handleBack} disabled={hasApiCallInProgress} />
				<PageHeading isFlush data-test-id="review-page">
					{content.PageHeader}
				</PageHeading>
				<p className="u-margin-top-1">{content.PageSubHeader}</p>
				<div className="u-margin-bottom-2">
					<Notifications />
				</div>
				{isBatch ? <ReviewBatch contentKey={reviewContent} /> : <ReviewPayments contentKey="content" />}
				<EnhancedBatchProgressTakeover contentKey="reviewPayments" />
				<PageNavigation
					handleContinue={this.handleContinue}
					showContinue={canContinue}
					enableContinue={!hasApiCallInProgress && !authorisersRequired}
					showBack
					handleBack={handleBack}
					enableBack={!hasApiCallInProgress}
					continueButtonText={content.continueButtonText}
					showLoading={hasApiCallInProgress}
				/>
			</div>
		);
	}
}

Review.propTypes = {
	authorisersRequired: PropTypes.bool,
	canContinue: PropTypes.bool.isRequired,
	handleBack: PropTypes.func.isRequired,
	isBatch: PropTypes.bool.isRequired,
	content: PropTypes.shape(contentPropTypes),
	hasApiCallInProgress: PropTypes.bool.isRequired,
	handlePaymentInReview: PropTypes.func.isRequired,
	isTransferOrCCPayment: PropTypes.func.isRequired,
	handleContinue: PropTypes.func.isRequired,
	isTRAObligate: PropTypes.bool,
	navigateToEffectiveWarningPage: PropTypes.func.isRequired,
	isManagePaymentEdit: PropTypes.bool.isRequired,
};

const contentWrapper = withContent({ content: reviewContent });
export default compose(connect(mapState, mapDispatch), withScrollTop, contentWrapper)(Review);
export const ConnectWrapper = connect(mapState, mapDispatch)(Review);
